import { useEffect, useState, useCallback } from "react";
import "@/App.css";
import { Loader2 } from "lucide-react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import api from "@/lib/api";
import { Gate } from "@/components/Gate";
import { Deck } from "@/components/Deck";
import { PresenterView } from "@/components/PresenterView";

function MainDeck() {
  const [status, setStatus] = useState("loading"); // loading | gate | deck

  useEffect(() => {
    api
      .get("/deck/session")
      .then((res) => setStatus(res.data.authenticated ? "deck" : "gate"))
      .catch(() => setStatus("gate"));
  }, []);

  const handleLogout = useCallback(async () => {
    try {
      await api.post("/deck/logout");
    } catch (e) {
      /* ignore */
    }
    setStatus("gate");
  }, []);

  if (status === "loading") {
    return (
      <div className="stage-wrap">
        <Loader2 className="w-6 h-6 animate-spin text-ink-soft" />
      </div>
    );
  }
  if (status === "gate") {
    return <Gate onAuthed={() => setStatus("deck")} />;
  }
  return <Deck onLogout={handleLogout} />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/presenter" element={<PresenterView />} />
          <Route path="*" element={<MainDeck />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
